import React from "react";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "comment-div": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

class CommentDivElement extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
  }

  static get observedAttributes() {
    return ["class", "style"];
  }

  // Called when observed attributes change
  attributeChangedCallback(_name: string, oldValue: string, newValue: string) {
    if (oldValue !== newValue) {
      this.render();
    }
  }

  private render() {
    const className = this.getAttribute("class") || "";
    const style = this.getAttribute("style") || "";

    this.shadowRoot!.innerHTML = `
      <style>
        :host { display: block; }
      </style>
      <div class="${className}" style="${style}">
        <slot></slot>
      </div>
    `;
  }
}

customElements.define("comment-div", CommentDivElement);

/**
 * CommentDiv: An encapsulated custom element, unaffected by external div styling
 */
const CommentDiv = ({ children, className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  const webComponentProps = {
    ...props,
    // web components use 'class' instead of 'className', so we map the replacement
    ...(className && { class: className }),
  };

  return React.createElement("comment-div", webComponentProps, children);
};

export default CommentDiv;
